import styled, { css } from 'styled-components';
import Image from 'next/image';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279, MAX_1365, MAX_767, MIN_1680, MIN_480 } from '~/src/styles/tokens/break-points';

export const BannerImage = styled(Image)`
    position: absolute;
    right: ${rem(40)};
    bottom: 0;

    ${mediaQuery(
        { minWidth: MIN_1680 },
        css`
            right: ${rem(12)};
            width: ${rem(340)};
            height: ${rem(230)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MIN_1680 },
        css`
            right: ${rem(12)};
            width: ${rem(300)};
            height: ${rem(200)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1365 },
        css`
            right: ${rem(12)};
            width: ${rem(280)};
            height: ${rem(212)};
        `,
    )};
`;

export const BackgroundImageLine = styled(Image)`
    position: absolute;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            top: 2px;
            right: 0;
        `,
    )};

    ${mediaQuery(
        { minWidth: MIN_480, maxWidth: MAX_767 },
        css`
            top: 4px;
            right: 2px;
        `,
    )};
`;

export const BackgroundImageEllipse = styled(Image)<{ isReferralUrl: boolean; }>`
    position: absolute;

    ${(p) =>
        mediaQuery(
            { maxWidth: MAX_1279 },
            css`
                right: ${p.isReferralUrl ? 0 : rem(-10)};
                bottom: ${p.isReferralUrl ? rem(-38) : rem(-60)};
            `,
        )};

    ${(p) =>
        mediaQuery(
            { maxWidth: MAX_767 },
            css`
                right: ${p.isReferralUrl ? 0 : rem(-10)};
                bottom: ${p.isReferralUrl ? rem(-38) : rem(-44)};
            `,
        )};
`;
